import { Box, Link, styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { EmailSupportLink } from "@rentablo/components";
import { PhoneSupportLink } from "./PhoneSupportLink";

const SidebarInfoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 3,
}));

export const SidebarInfo = () => {
  const { t } = useTranslation();

  return (
    <SidebarInfoContainer>
      <PhoneSupportLink variant="extended" />
      <EmailSupportLink variant="extended" />
      <Box mt={5} ml={8}>
        <Box display="flex" alignItems="center">
          <Link
            href={`${import.meta.env.VITE_APP_V2_URL}/impressum`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="body3">
              {t(`sidebar.footer.imprint`)}
            </Typography>
          </Link>
          <Typography mx={2} color="textSecondary">
            •
          </Typography>
          <Link
            href={`${import.meta.env.VITE_APP_V2_URL}/privacy`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="body3">
              {t("sidebar.footer.privacy")}
            </Typography>
          </Link>
        </Box>
        <Typography variant="body3" color="textSecondary">
          © {t("sidebar.footer.wealthApi")}
        </Typography>
      </Box>
      {/*<Box display="flex" gap={3} alignItems="center">*/}
      {/*  <IconContainer><ChatIcon /></IconContainer>*/}
      {/*  <Box>*/}
      {/*    <Typography color="common.M400" variant="body3">*/}
      {/*      Chat*/}
      {/*    </Typography>*/}
      {/*  </Box>*/}
      {/*</Box>*/}
    </SidebarInfoContainer>
  );
};
